import { trackRudderstack } from "jiffy-analytics";

function computeHoursFromNow(deliveryDate) {
  if (!deliveryDate) return null;
  const deliveryMs = new Date(deliveryDate).getTime();
  if (Number.isNaN(deliveryMs)) return null;
  return Math.round((deliveryMs - Date.now()) / (1000 * 60 * 60));
}

export default function trackDeliveryOptionsLoaded(response) {
  const orderId = response?.order_id;
  const orders = response?.shipments?.orders || {};
  Object.values(orders).forEach(order => {
    (order.options || []).forEach(option => {
      trackRudderstack("Cart Delivery Option Loaded", {
        order_id: orderId,
        type: order.title,
        category: option.category,
        delivery_date: option.delivery_date,
        shipping_method: option.shipping_method,
        location_codes: option.location_codes,
        valid_until_time: option.valid_until_time,
        zipcode: order.zipcode,
        hours_from_now: computeHoursFromNow(option.delivery_time || option.delivery_date),
        business_line: order.business_line
      });
    });
  });
}
